import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-uncategorized-notice',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule],
  templateUrl: './uncategorized-notice.component.html',
  styleUrls: ['./uncategorized-notice.component.scss'],
})
export class UncategorizedNoticeComponent {
  @Input({ required: true }) count = 0;
}
